import "./style.css";

const SOCIAL_URLS = {
  twitter: "https://twitter.com/intent/tweet?",
  linkedin: "https://www.linkedin.com/shareArticle?mini=true&",
};
const WIN_PARAMS =
  "scrollbars=0, resizable=1, menubar=0, left=100, top=100, width=550, height=440, toolbar=0, status=0";

export default class Share {
  static selector = ".share";

  constructor(block) {
    this.block = block;

    this.twitterButton = this.block.querySelector(".share__twitter");
    this.linkedinButton = this.block.querySelector(".share__linkedin");
    this.url = this.twitterButton.dataset.url;

    this.twitterButton &&
      this.twitterButton.addEventListener("click", this.handleClick);
    this.linkedinButton &&
      this.linkedinButton.addEventListener("click", this.handleClick);
  }

  encodeParams = (obj) => {
    return Object.keys(obj)
      .filter(function (k) {
        return typeof obj[k] !== "undefined" && obj[k] !== "";
      })
      .map(function (k) {
        return ""
          .concat(encodeURIComponent(k), "=")
          .concat(encodeURIComponent(obj[k]));
      })
      .join("&");
  };

  handleClick = (e) => {
    const params = {
      url: this.url,
    };
    if (e.currentTarget.className === "share__twitter") {
      this.handleShare(params, SOCIAL_URLS.twitter);
    } else {
      this.handleShare(params, SOCIAL_URLS.linkedin);
    }
  };

  handleShare = (params, url) => {
    const encodedParams = this.encodeParams(params);
    return window.open(`${url}`.concat(encodedParams), "_blank", WIN_PARAMS);
  };
}
